import { render, staticRenderFns } from "./Student_Accounts.vue?vue&type=template&id=1b00373c&scoped=true&"
import script from "./Student_Accounts.vue?vue&type=script&lang=js&"
export * from "./Student_Accounts.vue?vue&type=script&lang=js&"
import style0 from "./Student_Accounts.vue?vue&type=style&index=0&id=1b00373c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00373c",
  null
  
)

export default component.exports